// バナー要素の型定義
type FloatBanner = HTMLElement;

// メイン処理を実行する関数
const initFloatBannerToggle = (): void => {
  // 必要な要素の取得
  const footer = document.querySelector('footer');
  const floatBanner = document.querySelector('.js-floatBanner') as FloatBanner;

  // 要素が存在しない場合は処理を終了
  if (!footer || !floatBanner) {
    console.warn('Required elements not found');
    return;
  }

  // アニメーションの定義
  const fadeOutAnimation = [
    { opacity: 1, transform: 'translateY(0)' },
    { opacity: 0, transform: 'translateY(20px)' },
  ];

  const fadeInAnimation = [
    { opacity: 0, transform: 'translateY(20px)' },
    { opacity: 1, transform: 'translateY(0)' },
  ];

  const animationTiming: KeyframeAnimationOptions = {
    duration: 300,
    easing: 'ease-out',
    fill: 'forwards',
  };

  // バナーの表示状態を管理する変数
  let isVisible = true;

  // Intersection Observerの設定
  const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1, // footerが10%見えた時点で発火
  };

  // バナーを非表示にする関数
  const hideBanner = () => {
    if (!isVisible) return;

    floatBanner.animate(fadeOutAnimation, animationTiming);
    setTimeout(
      () => {
        floatBanner.style.display = 'none';
      },
      typeof animationTiming.duration === 'number'
        ? animationTiming.duration
        : 300
    );
    isVisible = false;
  };

  // バナーを表示する関数
  const showBanner = () => {
    if (isVisible) return;

    floatBanner.style.display = 'block';
    floatBanner.animate(fadeInAnimation, animationTiming);
    isVisible = true;
  };

  // Intersection Observerのコールバック関数
  const observerCallback: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // footerが見えたらバナーを非表示
        hideBanner();
      } else {
        // footerが見えなくなったらバナーを表示
        showBanner();
      }
    });
  };

  // Intersection Observerのインスタンス化
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // footer要素の監視を開始
  observer.observe(footer);
};

// DOMの読み込み完了後に実行
document.addEventListener('DOMContentLoaded', initFloatBannerToggle);
